const rawApiBaseUrl = process.env.REACT_APP_API_BASE_URL?.trim();

if (!rawApiBaseUrl) {
  throw new Error("REACT_APP_API_BASE_URL is required.");
}

export const API_BASE_URL = rawApiBaseUrl.replace(/\/$/, "");

console.log("API_BASE_URL", API_BASE_URL);

const API_RETRY_DELAYS_MS = [1500, 3500, 7000];

function buildApiUrl(path) {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
}

function wait(ms) {
  return new Promise((resolve) => {
    window.setTimeout(resolve, ms);
  });
}

export async function fetchJson(path, options = {}) {
  const { onRetry, retries = API_RETRY_DELAYS_MS.length } = options;

  for (let attempt = 0; attempt <= retries; attempt += 1) {
    try {
      const response = await fetch(buildApiUrl(path));

      if (!response.ok) {
        throw new Error(`API request failed: ${response.status} ${path}`);
      }

      return await response.json();
    } catch (error) {
      if (attempt >= retries) {
        throw error;
      }

      const retryAttempt = attempt + 1;
      onRetry?.(retryAttempt);
      await wait(API_RETRY_DELAYS_MS[Math.min(attempt, API_RETRY_DELAYS_MS.length - 1)]);
    }
  }

  throw new Error(`API request failed: ${path}`);
}
